import React, { useMemo } from 'react';
import { Open } from '@drift-labs/icons';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import useUserAccountIsReady from 'src/hooks/useUserAccountIsReady';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import healthDependentClassName from 'src/utils/healthDependentClassName';
import ValueWithLabelCard from 'src/components/primitives/ValueWithLabelCard/ValueWithLabelCard';
import useModal from 'src/components/Modals/hooks/useModal';
import useAppInitialLoad from 'src/hooks/app/useAppInitialLoad';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BigNum } from '@drift-labs/sdk';

export default function PortfolioHeaderAccountHealth() {
	const { show } = useModal();
	const { isInitialLoading } = useAppInitialLoad();
	const connected = useWalletIsConnected();
	const userAccountIsReady = useUserAccountIsReady();
	const userClient = useDriftAccountStore(
		(s) => s.accounts[s.currentUserKey ?? '']?.client
	);

	const health = useMemo(() => {
		if (!connected || !userAccountIsReady || !userClient) {
			return;
		}

		return userClient.getHealth();
	}, [connected, userAccountIsReady, userClient]);

	const healthBigNum = health ? BigNum.fromPrint(health.toString()) : undefined;

	return (
		<ValueWithLabelCard.Item label="Account Health" className="sm:items-end">
			<div className="flex items-center gap-x-xs">
				<NumberDisplay
					value={healthBigNum}
					type="percentage"
					className={healthDependentClassName(health, { type: 'text' })}
					loading={isInitialLoading}
					skeletonClassName="w-12 h-lg sm:h-2xl"
					trimZeroes
				/>
				{connected && (
					<IconButton
						size="sm"
						variant="tertiary"
						className="-m-sm p-sm"
						icon={Open}
						onClick={() => show({ type: 'account_health', props: {} })}
					/>
				)}
			</div>
		</ValueWithLabelCard.Item>
	);
}
